import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Store, select } from "@ngrx/store";
import { Observable, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { UserHistoryActionsEnum } from "src/app/shared/enum/userHistoryActions";
import { UserHistoryServicesEnum } from "src/app/shared/enum/userHistoryService";
import { SaveUserHistoryService } from "src/app/shared/services/history/saveHistory";
import { invokeSendVerificationEmail } from "src/app/store/advertiser/advertiser.actions";
import { advertiserAdvetisingCampaignsSelector } from "src/app/store/advertisingCampaign/advertiserCampaign.selectors";
import {
  invokeGetAdvertiserAdvetisingCampaigns,
  resultAdvertiserAdvetisingCampaigns,
} from "src/app/store/advertisingCampaign/advertisingCampaign.actions";
import { AppStateInterface } from "src/app/store/appState.interface";
import { catchForbiddenError, catchServerError } from "src/app/store/user/user.actions";
import {
  catchForbiddenErrorSelector,
  catchServerErrorSelector,
} from "src/app/store/user/user.selectors";

@Component({
  selector: "app-send-verification-email",
  templateUrl: "./send-verification-email.component.html",
})
export class SendVerificationEmailComponent extends BaseComponent implements OnInit {
  @Input() email: string;

  advertiserAdvetisingCampaigns$: Observable<string[] | null>;

  loading: boolean = false;

  catchServerError$: Observable<boolean | null>;
  catchForbiddenError$: Observable<boolean | null>;
  constructor(
    private store: Store<AppStateInterface>,
    private modalService: NgbModal,
    private saveHistory: SaveUserHistoryService
  ) {
    super(store);
    this.catchForbiddenError$ = this.store
      .pipe(select(catchForbiddenErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.catchServerError$ = this.store
      .pipe(select(catchServerErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.advertiserAdvetisingCampaigns$ = this.store
      .pipe(select(advertiserAdvetisingCampaignsSelector))
      .pipe(takeUntil(this.ngDestroyed$));
  }

  ngOnInit() {
    this.catchForbiddenError$.subscribe((result) => {
      if (result) {
        this.loading = false;
        this.closeModal();
        this.store.dispatch(catchForbiddenError({ forbiddenError: null }));
      }
    });
    this.catchServerError$.subscribe((result) => {
      if (result) {
        this.loading = false;
        this.closeModal();
        this.store.dispatch(catchServerError({ serverError: null }));
      }
    });
    if (this.email)
      this.store.dispatch(
        invokeGetAdvertiserAdvetisingCampaigns({ email: this.email })
      );
  }

  onClickSendEmail() {
    this.loading = true;
    this.store.dispatch(invokeSendVerificationEmail({ email: this.email }));
  }

  closeModal() {
    this.modalService.dismissAll();
  }
}
